export default {
  NETWORK_FAILED: "<bold>Mất kết nối đến máy chủ</bold><typography>Xin hãy kiểm tra lại kết nối</typography>",
};
